"use client";

import { Button } from "@ascra/ui/button";
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyTitle,
} from "@ascra/ui/empty";
import { ColoredLayout } from "@ascra/ui/layout";
import { useRouter, useSearchParams } from "next/navigation";
import { useTranslations } from "next-intl";
import { I18nText } from "@/components/i18n/i18n-text";
import { authClient } from "@/lib/auth/client";

export default function Unauthorized() {
	const t = useTranslations();
	const router = useRouter();
	const searchParams = useSearchParams();
	const requiredPermission = searchParams.get("permission");

	return (
		<ColoredLayout>
			<div className="flex min-h-screen w-full flex-col items-center justify-between">
				{/* Empty div to help center main content */}
				<div className="grow basis-0">
					<div className="h-24" />
				</div>
				<div className="relative flex w-full flex-col items-center justify-center px-4">
					<Empty>
						<EmptyHeader>
							<EmptyTitle className="font-bold font-mono text-6xl">
								401
							</EmptyTitle>
							<EmptyDescription className="text-lg">
								{t("auth.unauthorizedDescription")}
							</EmptyDescription>
							{requiredPermission ? (
								<EmptyDescription className="text-sm">
									<I18nText messageKey="m_ccb7c3cdd6a6" /> {requiredPermission}
								</EmptyDescription>
							) : null}
						</EmptyHeader>
						<EmptyContent>
							<Button
								onClick={() => {
									void authClient.signOut({
										fetchOptions: {
											onSuccess: () => {
												router.replace("/sign-in");
											},
										},
									});
								}}
							>
								{t("account.signOut")}
							</Button>
						</EmptyContent>
					</Empty>
				</div>
				{/* Empty div to help center main content */}
				<div className="flex grow basis-0 flex-col justify-end" />
			</div>
		</ColoredLayout>
	);
}
